// Core Components
import React from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import HelpIcon from '@mui/icons-material/Help';

const TitleBox = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const TitleIconBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1),
}));

export default function PageTitle(props) {
  const { Icon, title } = props;
  const TitleIcon = Icon ? Icon : HelpIcon;

  return (
    <TitleBox>
      <TitleIconBox component={TitleIcon} />
      {title}
    </TitleBox>
  );
}
